<div class="row">
  <div class="col-12">
    <rask-action-button class="float-end" (click)="add()" icon="far fa-plus" [disabled]="!hasRoleProduktAdmin">Lägg till</rask-action-button>
  </div>
</div>
@if (searchResult && dataLoaded) {
  <div class="row rhregelverk-table-wrapper">
    <rask-table class="col-12" [data]="searchResult" [columns]="colDef"></rask-table>
  </div>
}
<div class="row">
  <rask-button class="col-1"
    (click)="save()"
    [disabled]="!canSave()">
    Spara
  </rask-button>
</div>
